import PropTypes from 'prop-types';
import {connect} from 'react-redux'
import {useEffect, useRef} from "react";
import reduxStore from "redux/store";
import moment from "moment";


function AutoSaveFormValues({
	id,
	formId,
	saveFunc,
	formikProps,
	throttleTimeout = 30000,
	debounceTimeout = 10000,
	ignoreInitialCall = true,
	customDirtyRef
}) {

	const data = useRef({ firstTime: true, timeoutSetTime: null });

	useEffect(() => {
		const { firstTime, timeoutSetTime } = data.current;
		if (firstTime && ignoreInitialCall) {
			data.current.firstTime = false;
			return;
		}

		let throttleHandler;
		let debounceHandler;
		if (!!customDirtyRef ? customDirtyRef.current === "tak" : formikProps.dirty) {
			if (!timeoutSetTime || moment.now() - timeoutSetTime > throttleTimeout) {
				data.current.timeoutSetTime = moment.now();
			}
			throttleHandler = setTimeout(() => {
				clearTimeout(debounceHandler)
				const state = reduxStore.getState();
				saveFunc(state.formValues[formId]);
			}, throttleTimeout - (moment.now() - data.current.timeoutSetTime));
			debounceHandler = setTimeout(() => {
				clearTimeout(throttleHandler);
				data.current.timeoutSetTime = null;
				const state = reduxStore.getState();
				saveFunc(state.formValues[formId]);
			}, debounceTimeout);
		}

		return () => {
			clearTimeout(throttleHandler);
			clearTimeout(debounceHandler);
		};
		// eslint-disable-next-line
	}, [throttleTimeout, debounceTimeout, id, formikProps.values, !!customDirtyRef ? customDirtyRef.current : formikProps.dirty]);

	return null;
}

AutoSaveFormValues.propTypes = {
	classes: PropTypes.any,
	timeout: PropTypes.number
}

export default connect((state) => ({
}))(AutoSaveFormValues);